export default "__VITE_ASSET__77815181__"